module.exports = __webpack_public_path__ + "img/ecosystem-dne-bank.6b054ea7.svg";